<template>
  <Transition>
    <div
      v-if="visible"
      class="processing-dialog-container"
    >
      <div class="processing-box">
        <img
          @click="handleClose"
          class="close-icon"
          src="@/assets/images/close-icon.svg"
          alt=""
        >

        <img
          class="logo"
          src="@/assets/H5/carts/whatsApp-alert.svg"
          alt=""
        >
        <div class="text-1">
          Pending Processing ...
        </div>
        <div class="text-2">
          Your request will be processed within 1 business day. Note: Some items may face customs restrictions in your country. We're verifying clearance status. While waiting, consult our category experts free of charge.
        </div>
        <div
          @click="handleSkip"
          class="text-3"
        >
          Free Expert Consultation Now!
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue'
import { fetchData } from '@/utils/fetch'
import { useIntercom } from '@/hooks/useIntercom'

const emits = defineEmits(['close'])

const props = defineProps({
  visible: Boolean
})

const intercom = useIntercom()

watch(() => props.visible, value => {
  if (value) {
    document.body.style.overflow = 'hidden'
  }
})

const handleClose = () => {
  document.body.style.overflow = ''
  emits('close')
}

const handleSkip = async () => {
  intercom.showNewMessage()
}
</script>

<style lang='less' scoped>
.processing-dialog-container {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, .64);
  backdrop-filter: blur(4px);

  .processing-box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 316px;
    width: 400px;
    background-color: white;
    border-radius: 8px;
    padding: 16px 24px;

    .close-icon {
      position: absolute;
      top: 18px;
      right: 24px;
      cursor: pointer;
    }

    .text-1 {
      color: #232323;
      font-size: 16px;
      font-family: mon-600;
      line-height: 20px;
    }
    .text-2 {
      color: #232323;
      font-size: 12px;
      font-family: mon-500;
      line-height: 16px;
      margin-top: 16px;
    }
    .text-3 {
      color: #0073b3;
      font-size: 12px;
      font-family: mon-600;
      text-decoration: underline;
      margin-top: 8px;
      cursor: pointer;
      &:hover {
        color: var(--link-hover-color);
      }
    }
  }
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.3s ease-in-out;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
